import { Component, Input } from '@angular/core';
import { ChatMessage, ChatMessageAttribute } from 'src/app/models/chatMessage';
import { isPriceMessage, isPaymentConfirmedMessage } from 'src/app/utils/chat';
import { ExtLinkService } from 'src/app/services/ext-link/ext-link.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'chat-bubble',
  templateUrl: './chat-bubble.component.html',
  styleUrls: ['./chat-bubble.component.scss'],
})
export class ChatBubbleComponent {

  @Input() message: ChatMessage;
  @Input() email: string;
  @Input() loggedUserName: string;

  constructor(
    private extLink: ExtLinkService,
    private platform: Platform,
  ) { }

  isMy() {
    const { author = '' } = this.message;
    return this.email === author;
  }

  async download() {
    const url = this.platform.is('cordova') ? await this.message.media.getContentTemporaryUrl() : await this.message.media.getContentUrl();

    this.extLink.openBrowser(url, '_system');
  }

  isPriceMessage() {
    return isPriceMessage(this.message);
  }

  isPaymentConfirmedMessage() {
    return isPaymentConfirmedMessage(this.message);
  }

  isPayNowConfirmedMessage() {
    const { attributes = {} as ChatMessageAttribute } = this.message || {};
    const { type = '' } = attributes || {};
    return type === 'pay_now_confirmed';
  }

  isMediaMessage() {
    return this.message.type === 'media';
  }
}
